var map = {
	"./imag1.jpg": 3841,
	"./img10.jpg": 8136,
	"./img11.jpg": 5397,
	"./img12.jpg": 8058,
	"./img13.jpg": 7063,
	"./img14.jpg": 3276,
	"./img15.jpg": 649,
	"./img16.jpg": 4510,
	"./img2.jpg": 6661,
	"./img3.jpg": 4296,
	"./img4.jpg": 6971,
	"./img5.jpg": 5838,
	"./img6.jpg": 5897,
	"./img7.jpg": 4172,
	"./img8.jpg": 5119,
	"./img9.jpg": 7186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4655;